import rocketImage from './media/rocket.svg';

export const getNewUiWelcomeStyles = () => ({
  newUINavigationPreferenceDialog: {
    '& .ms-Dialog-header': {
      height: 198,
      backgroundPositionY: 'bottom',
      backgroundImage: `url("${rocketImage}")`,
      backgroundRepeat: 'no-repeat',
      backgroundColor: '#C7E0F4',
      backgroundSize: 'contain',
    },

    '& .ms-Dialog-inner': {
      padding: 0,
    },

    '& .ms-Dialog-button--close': {
      color: '#005A9E',
      padding: 'unset',
      width: 'unset',
      height: 'unset',

      '& .ms-Button-flexContainer': {
        width: 'unset',
        height: 'unset',

        '& .ms-Button-icon': {
          margin: 'unset',
        },
      },
    },

    '& .ms-Dialog-button--close:hover, & .ms-Dialog-button--close:active': {
      backgroundColor: '#C7E0F4',
    },

    '& .ms-Dialog-button, .ms-Dialog-button:hover': {
      color: '#0078d4',
      backgroundColor: 'transparent',
    },

    '& .custom-content-wrapper': {
      background: '#0078d4',
      color: '#ffffff',
      padding: 18,

      '& a': {
        color: 'white',
        textDecorationLine: 'underline',
      },

      '& .hiddenSpan': {
        display: 'none',
      },

      '& .title': {
        fontWeight: 600,
        fontSize: '20px',
        lineHeight: '27px',
        marginBottom: 14,
      },

      '& .ms-Dialog-actions': {
        background: '#0078d4',
        marginTop: '24px 0 0 0',

        '& .ms-Dialog-actionsRight': {
          display: 'flex',
          textAlign: 'left !important',
          margin: 'unset',

          '& .ms-Dialog-action': {
            margin: 'unset',
          },

          '& .ms-Button--primary': {
            border: '1px solid white',
          },

          '& .lets-go, & .lets-go:hover, & .lets-go:focus:after': {
            border: '1px solid white',
            color: '#0078d4',
          },

          '& button': {
            marginRight: 11,
          },
        },
      },
    },

  },
});
